import axios from "axios";
import { getToken, logout } from "./auth";
const jwt = require('jsonwebtoken');

var time;
var usuario;
var rota;


const api = axios.create({
    baseURL: process.env.REACT_APP_API_IRRIGACAO_URL
});

api.interceptors.request.use((request) => {
    rota = request.url;
    const token = request.headers.Authorization.split(' ')[1];
    const decode = jwt.verify(token,
        'segredo'
    )
    usuario = decode;
    time = new Date().getTime();
    return request;
});

api.interceptors.request.use(async config => {
    const access_token = getToken();
    if (access_token) {
        config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    async function (error) {
        const access_token = getToken();
        if (error && error.response && error.response.status === 401 && access_token) {
            logout();
            return;
        }
        return Promise.reject(error);
    }
);

api.interceptors.response.use((response) => {
    
    if (response.status === 200) {

        if (!response.config.url.match(/audit/) || !response.config.url.match(/report/)) {
            var tempo = new Date().getTime() - time;

            axios.post(`${process.env.REACT_APP_API_IRRIGACAO_URL}/audit`, { api: 'irrigacao', user: usuario.usuario, time: tempo, rota: rota }).then((response) => {
            });
        }
    }

    return response;
});


export default api;